<div class="tile-head flex-row flex-vertical-center">
  <cigna-icon
    class="dashboard-icon"
    [type]="CignaIcon.EnvelopeClosed"
  ></cigna-icon>
  <h3 class="cg-h3">Messages</h3>
  <!-- code below has no functionality at this point -->
  <!-- <div class="view">
    <span>View: </span>
    <button cignaButton="link inline no-underline" data-test="view">
      {{ viewToDisplayMap[view] }}
      <cigna-icon type="caretDownIcon"></cigna-icon>
    </button>
  </div> -->
</div>

<ng-container
  *cignaWaitToLoad="
    messages;
    let messagesData;
    errorState: error;
    loadingState: loading
  "
>
  <div *ngIf="messagesData?.length; else noMessages" class="message-list">
    <ng-container
      *ngFor="let message of messagesData; let i = index; trackBy: trackByFunc"
    >
      <cigna-message-tile-widget
        [message]="message"
        [isImpersonator]="isImpersonator"
        [attr.data-test]="'message-' + i"
        (updateMessages)="updateMessages.emit($event)"
        (deleteMessages)="deleteMessages.emit($event)"
      >
      </cigna-message-tile-widget>
    </ng-container>
  </div>
</ng-container>

<div class="footer">
  <a cignaButton="link" [routerLink]="['/message-center']"
    >Go to message center</a
  >
</div>

<ng-template #noMessages>
  <div class="no-messages" data-test="no-messages">
    <cigna-icon [type]="CignaIcon.EnvelopeOpen" class="icon"></cigna-icon>
    <div>
      There were no messages found. Please edit your search and filter criteria
      or check the archive.
    </div>
  </div>
</ng-template>

<ng-template #error let-e>
  <div
    *ngIf="e?.code || e?.status"
    data-test="error-msg"
    class="cg-error-msg-large cg-margin-bottom-lg"
  >
    <cigna-icon type="exclamation-circle"></cigna-icon>
    <div data-spa-service-error>
      MCLMSGT{{ e.code ? e.code : e.status }}:
      <span> {{ e.errObject.message }} </span>
    </div>
  </div>
</ng-template>

<ng-template #loading>
  <div class="loading" data-test="loading">
    <div class="cg-spinner"></div>
  </div>
</ng-template>
